/* eslint-disable no-console */
import axios from "axios";
import ApiService from "@/services/api.service";
import { ManifestService } from "@/services/api.service";
//import { FETCH_MANIFEST } from "./actions.type";
import { RESET_STATE, SET_MANIFEST } from "./mutations.type";
import { API_URL } from "@/services/config.service";

const state = {
  manifest: [],
  apiUrl: API_URL + "/manifest",
  axiosConfig: {
    headers: {
      "Content-Type": "application/json"
    }
  }
};

const getters = {
  allManifest: state => state.manifest
};

export const mutations = {
  [SET_MANIFEST]: (state, payload) => (state.manifest = payload),
  addManifest: (state, payload) => state.manifest.push(payload),
  deleteManifest: (state, index) => state.manifest.splice(index, 1)
};

// export const actions = {
//   async [FETCH_MANIFEST](context, slug) {
//     const { data } = await ManifestService.get(slug);
//     context.commit(SET_MANIFEST, data.manifest);
//     return data.manifest;
//   },
//   [RESET_STATE]({ commit }) {
//     commit(RESET_STATE);
//   }
//   // async [VARIFIED_CARD](context, payload) {
//   //   //console.log(payload)
//   //   const { data } = await InsuranceService.post(payload.slug, payload.data);
//   //   return data;
//   // }
// };

const actions = {
  fetchManifest: async (context, slug) => {
    try {
      // const response = await axios.get(state.apiUrl, state.axiosConfig);
      const response = await ManifestService.get(slug);
      context.commit(SET_MANIFEST, response.data.manifest);
      return response.data.manifest;
    } catch (error) {
      context.commit(SET_MANIFEST, []);
    }
  },
  saveManifest: async ({ state }, payload) => {
    try {
      let response = await axios.post(
        state.apiUrl + "/add",
        payload,
        state.axiosConfig
      );

      if (response.data.message.error) {
        return { error: response.data.message.error };
      }

      if (response.status == 200) {
        return { success: response.data.message.success };
      }
    } catch (error) {}
  },
  importManifest: async ({ state }, payload) => {
    console.log(payload);
    try {
      let response = await axios.post(state.apiUrl + "/import", payload, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });

      if (response.data.message.error) {
        //console.log(response.data)
        return { error: response.data.message.error };
      }

      if (response.status == 200) {
        return { success: response.data.message.success };
      }
    } catch (error) {
      //console.log("error" + error);
      return { error: error };
    }
  },
  updateManifest: async ({ state }, payload) => {
    try {
      let response = await axios.put(
        state.apiUrl + "/" + payload["id"],
        payload,
        state.axiosConfig
      );
      if (response.status == 200) {
        //state.dispatch("setManifest", payload);
        return { success: response.data.message.success };
      }
    } catch (error) {}
  },
  setDepartureDate: async ({ state }, payload) => {
    try {
      let response = await axios.put(
        state.apiUrl + "/depart/" + payload["id"],
        payload.item,
        state.axiosConfig
      );
      if (response.status == 200 && response.data.message.success) {
        return { success: response.data.message.success };
      } else if (response.status == 200 && response.data.message.error) {
        return { error: response.data.message.error };
      }
    } catch (error) {}
  },
  deleteManifest: async ({ state }, payload) => {
    try {
      let { response } = await axios.delete(
        state.apiUrl + "/" + payload["manifest_id"],
        state.axiosConfig
      );
      if (response.status == 200) {
        state.dispatch("deleteManifest", state.countries.indexOf(payload));
        state.notification.push({ message: response.data });
      }
    } catch (error) {}
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
